//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const BPWApprovedGrantAgreementsWidget = ({ count }: { count: number }) => {
  return (
    <StatCard title='BPW Approved Grant Agreements' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />
  );
};

export default BPWApprovedGrantAgreementsWidget;
